import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';

@Component({
  selector: 'app-supply-chain-delivered-costs-calculator',
  templateUrl: './supply-chain-delivered-costs-calculator.component.html',
  styleUrls: ['./supply-chain-delivered-costs-calculator.component.css']
})
export class SupplyChainDeliveredCostsCalculatorComponent implements OnInit {

  form;
  ngOnInit () {

    this.form = new FormGroup ( {

    value1: new FormControl(''),
    value2: new FormControl(''),
    value3: new FormControl(''),
    value4: new FormControl(''),
    value5: new FormControl(''),
    value6: new FormControl(''),
    } )

  } 
  deliCost(n1,n2,n3,n4,n5,n6){
    var  deliCo=n1+n2+n3+n4+n5+n6;
    var  deliCosimple=  deliCo.toFixed(2);
    return  deliCosimple ;
    }

}



// WEBPACK FOOTER //
// C:/my-dream-app/src/app/supply-chain-delivered-costs-calculator/supply-chain-delivered-costs-calculator.component.ts